// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1OPHa","title":"Images90_title__3gZFy","images":"Images90_images__vOI0r"};